import React from 'react'
import PropTypes from 'prop-types'

import { graphql, compose, withApollo } from 'react-apollo'

import AppBar from '@material-ui/core/AppBar'
import Toolbar from '@material-ui/core/Toolbar'
import IconButton from '@material-ui/core/IconButton'
import Button from '@material-ui/core/Button'
import LinearProgress from '@material-ui/core/LinearProgress'

import { styles } from './styles'
import { UPLOAD_DOCUMENT } from '../../graphql/mutations'
import Logo from '../../components/Logo'
import Title from '../../components/Title'
import HeroDocument from '../../components/HeroDocument'
import { withContext } from '../../context'

export const Document = ({ history: { replace }, context: { state } }) => {
  return (
    <main style={styles.main}>
      <AppBar position="sticky">
        <Toolbar style={styles.toolbar}>
          <IconButton style={{ width: '48px' }} />
          <Logo />
          <IconButton style={{ width: '48px' }} />
        </Toolbar>
        {state.uploading ? (
          <LinearProgress />
        ) : (
          <div style={{ height: '4px' }} />
        )}
      </AppBar>

      <Title name="ส่งไฟล์จำเป็น" />
      <HeroDocument />
      <div style={styles.buttonWrapper}>
        <Button
          style={styles.button}
          fullWidth
          variant="contained"
          color="primary"
          id="btnUpload"
          aria-label="Menu"
          onClick={() => replace('product')}
        >
          Next
        </Button>
      </div>
    </main>
  )
}

Document.propTypes = {
  history: PropTypes.object.isRequired,
  context: PropTypes.object.isRequired
}

export default compose(
  withApollo,
  withContext,
  graphql(UPLOAD_DOCUMENT, { name: 'UploadDocument' })
)(Document)



// WEBPACK FOOTER //
// ./src/pages/Document/index.js